var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-select',{attrs:{"items":_vm.opcoes,"label":"Pedidos Recorrentes","item-text":"text","item-value":"value"},model:{value:(_vm.opcaoSelecionada),callback:function ($$v) {_vm.opcaoSelecionada=$$v},expression:"opcaoSelecionada"}})}
var staticRenderFns = []

export { render, staticRenderFns }